import React from "react";

export function Spinner({ className = "" }) {
  return (
    <div className={`inline-block h-6 w-6 animate-spin rounded-full border-[3px] border-slate-200 border-t-navy ${className}`} />
  );
}

export function PageLoader() {
  return (
    <div className="flex h-[60vh] w-full items-center justify-center" data-testid="page-loader">
      <div className="flex flex-col items-center gap-3">
        <Spinner className="h-9 w-9" />
        <p className="text-sm text-slate-400">جارٍ التحميل...</p>
      </div>
    </div>
  );
}

export function CardSkeleton({ count = 3 }) {
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="animate-pulse rounded-2xl border border-slate-100 bg-white p-6 soft-shadow">
          <div className="mb-4 h-32 w-full rounded-xl bg-slate-100" />
          <div className="mb-2 h-4 w-2/3 rounded bg-slate-100" />
          <div className="h-3 w-1/2 rounded bg-slate-100" />
        </div>
      ))}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, desc, action }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-white/60 py-16 text-center" data-testid="empty-state">
      {Icon && (
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-50 text-slate-300">
          <Icon className="h-8 w-8" />
        </div>
      )}
      <h3 className="font-heading text-lg font-bold text-navy">{title}</h3>
      {desc && <p className="mt-1 max-w-sm text-sm text-slate-400">{desc}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
